import React, { memo } from 'react';
import { ClockCircleOutlined, UpSquareOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { statusColor } from '@helpers/index';
import { StencilNotUploadedProps } from './types';

const StencilNotUploaded = ({
  stencil,
  worker,
  actions,
}: StencilNotUploadedProps) => {
  const isUploadDisabled = actions.uploadDisabled ?? actions.disabled;
  return (
    <Space
      size="small"
      direction="vertical"
      className="flex flex-col items-center justify-center"
    >
      <ClockCircleOutlined
        style={{
          fontSize: '10px',
          visibility: 'hidden',
        }}
      />
      <UpSquareOutlined
        style={{
          fontSize: '30px',
          color: statusColor.grey,
          pointerEvents: (!actions.canUpload || isUploadDisabled) ? 'none' : 'auto',
        }}
        onClick={() => actions.onUpload({
          stencil,
          workerId: worker?.id as number,
          indefiniteTerm: false,
          expirable: stencil?.expirable,
        })}
        disabled={isUploadDisabled}
      />
    </Space>
  );
};

export default memo(StencilNotUploaded);
